import apiClient from './apiClient'
import { API_CONFIG } from './config'
import {
  mockApplications,
  mockApplicationDetails,
  delay,
} from './mockData'

// Fetch all applications from ARMS
const getApplications = async () => {
  if (API_CONFIG.useMockData) {
    console.log('📦 Using mock data: applications')
    return delay(mockApplications)
  }
  
  const response = await apiClient.get('/Applications')
  return response.data
}

// Fetch application details by ID
const getApplicationDetails = async (applicationId) => {
  if (API_CONFIG.useMockData) {
    console.log('📦 Using mock data: application details', applicationId)
    return delay(mockApplicationDetails[applicationId] || mockApplicationDetails[1])
  }
  
  const response = await apiClient.get(`/Applications/${applicationId}`)
  return response.data
}

const applicationService = {
  getApplications,
  getApplicationDetails,
}

export default applicationService
